import {
    DescriptionOutlined,
    FolderZipOutlined,
    ImageOutlined,
    InsertDriveFileOutlined,
    PictureAsPdfOutlined,
    TableChartOutlined,
} from "@mui/icons-material";

import { colors } from "../theme/tokens";

// File-type icon for the Documents page rows and the upload queue.

export function FileTypeIcon({ name, contentType, size = 22 }: { name: string; contentType?: string; size?: number }) {
    const n = name.toLowerCase();
    const sx = { fontSize: size, color: colors.mediumGray, flexShrink: 0 } as const;
    if (n.endsWith(".pdf") || contentType === "application/pdf") return <PictureAsPdfOutlined sx={sx} />;
    if (/\.(png|jpe?g|gif|webp|tiff?|heic|heif|bmp|svg|psd|ai)$/.test(n) || contentType?.startsWith("image/")) {
        return <ImageOutlined sx={sx} />;
    }
    if (/\.(xlsx?|xlsm|csv|tsv|numbers|ods)$/.test(n)) return <TableChartOutlined sx={sx} />;
    if (/\.(zip|rar|7z|tar|gz)$/.test(n)) return <FolderZipOutlined sx={sx} />;
    if (/\.(docx?|pages|rtf|txt|md)$/.test(n)) return <DescriptionOutlined sx={sx} />;
    return <InsertDriveFileOutlined sx={sx} />;
}
